module.exports = __webpack_public_path__ + "img/AI.98b47a94.jpg";